import { Moon, Sun } from "lucide-react";
import { motion } from "framer-motion";
import { useTheme } from "@/app/providers/ThemeProvider";

export const ThemeToggle = () => {
    const { theme, setTheme } = useTheme();
    const isDark = theme === "dark";

    const toggleTheme = () => {
        setTheme(isDark ? "light" : "dark");
    };

    return (
        <div
            onClick={toggleTheme}
            className="w-16 h-8 bg-blue-100 dark:bg-blue-600/20 rounded-full flex items-center px-1 cursor-pointer relative transition-colors duration-300"
        >
            {/* Sliding thumb */}
            <motion.div
                layout
                transition={{ type: "spring", stiffness: 300, damping: 25 }}
                className="absolute w-6 h-6 bg-white rounded-full shadow-md flex items-center justify-center"
                style={{
                    left: isDark ? "calc(100% - 28px)" : "4px",
                }}
            >
                {isDark ? (
                    <Moon className="text-black" size={14} />
                ) : (
                    <Sun className="text-black" size={14} />
                )}
            </motion.div>
        </div>
    );
};

export default ThemeToggle;
